var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjective75({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1553_13608)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2257 20.5049C31.037 20.6164 30.4712 20.8007 29.7178 20.6455C28.776 20.4514 27.6437 21.1208 27.9823 21.3711C28.1147 21.469 28.5237 21.541 28.9952 21.6241C29.7296 21.7535 30.6157 21.9097 30.8445 22.2317C31.145 22.6547 31.4212 22.7417 31.5218 22.7323L31.2257 20.5049ZM31.2521 20.477C31.4655 20.5511 32.0659 20.6267 32.76 20.3364C33.6278 19.9736 34.9081 20.418 34.6435 20.7245C34.5401 20.8444 34.1601 20.99 33.7219 21.1579C33.0395 21.4195 32.2161 21.7351 32.0775 22.0913C31.8954 22.5593 31.6488 22.6951 31.5482 22.7045L31.2521 20.477Z",
    fill: "#03825C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8233 14.5254C29.8383 9.32016 25.7708 5.23263 19.7963 5.42325C13.8219 5.61387 8.20058 10.0122 8.18559 15.2158C8.18559 15.2158 7.65798 25.7767 17.7396 34.2309C18.5776 34.8242 20.1752 34.7322 20.8437 34.1318C30.9758 25.0344 29.8252 14.5254 29.8252 14.5254L29.8233 14.5254ZM18.9874 20.7895C15.2336 20.9093 12.1993 18.3553 12.2088 15.0874C12.2182 11.8196 15.2695 9.07145 19.0215 8.95174C22.7734 8.83203 25.8095 11.3859 25.8001 14.6538C25.7907 17.9217 22.7393 20.6698 18.9874 20.7895Z",
    fill: "#03825C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.021 14.4726C31.0397 9.24793 26.224 5.13893 20.2663 5.29236C14.3086 5.4458 9.46275 9.80527 9.44411 15.0283C9.44411 15.0283 8.9105 25.6254 18.9576 34.1752C19.6204 34.7393 20.7041 34.7114 21.3711 34.113C31.481 25.0458 31.0229 14.4725 31.0229 14.4725L31.021 14.4726ZM20.2114 20.6914C16.4681 20.7878 13.4443 18.205 13.456 14.925C13.4677 11.6449 16.5124 8.90586 20.2538 8.8095C23.9952 8.71315 27.0209 11.2959 27.0092 14.5759C26.9975 17.8559 23.9528 20.595 20.2114 20.6914Z",
    fill: "#2AC682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 21.1118C24.0417 21.0093 27.26 18.0968 27.2724 14.6065C27.2848 11.1163 24.0866 8.37002 20.129 8.47255C16.1714 8.57509 12.9531 11.4876 12.9407 14.9778C12.9283 18.4681 16.1266 21.2143 20.0842 21.1118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.952 14.8933C18.2975 14.8844 18.5792 14.4494 18.5811 13.9216C18.5829 13.3938 18.3044 12.9731 17.9589 12.982C17.6133 12.9909 17.3317 13.4259 17.3298 13.9537C17.3279 14.4815 17.6065 14.9022 17.952 14.8933Z",
    fill: "#03825C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.125 12.1875C17.4454 11.9112 18.0195 12.371 18.6775 12.365",
    stroke: "#03825C",
    strokeWidth: 0.685014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.9034C22.1911 14.9011 21.9489 14.4661 21.9733 13.9317C21.9977 13.3974 22.2793 12.9661 22.6024 12.9684C22.9254 12.9708 23.1675 13.4058 23.1431 13.9402C23.1188 14.4745 22.8371 14.9058 22.5141 14.9034Z",
    fill: "#03825C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3854 12.1638C23.0821 11.8656 22.488 12.3883 21.8353 12.3973",
    stroke: "#03825C",
    strokeWidth: 0.685014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2365 10.3497C21.5225 11.8108 13.0163 10.9585 9.72738 10.3497C9.50313 9.9438 9.95162 9.74087 10.1759 9.74087C10.4001 9.74087 10.4001 9.53793 10.4001 9.33499C10.4001 9.13206 10.4001 8.92912 10.8486 8.92912C11.2971 8.92912 11.0728 8.72619 11.0728 8.52325C11.0728 8.3609 11.3718 8.32031 11.5213 8.32031C22.285 10.1467 28.1153 8.32031 28.3395 8.32031C28.5637 8.32031 28.5637 8.52325 28.5637 8.72619C28.5637 8.92912 28.788 8.92912 29.0122 9.13206C29.2365 9.33499 29.2365 9.13206 29.2365 9.53793C29.2365 9.9438 29.2365 9.74087 29.4607 9.9438C29.6401 10.1062 29.386 10.282 29.2365 10.3497Z",
    fill: "#03825C",
    stroke: "#03825C",
    strokeWidth: 1.26207
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3186 18.0625L35.5998 17.1273",
    stroke: "#005A44",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.762 24.6667L30.9529 18.0898",
    stroke: "#005A44",
    strokeWidth: 1.4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1581 34.3293L29.245 27.4495C29.1436 26.6851 29.541 25.1002 31.9425 24.8758C34.344 24.6515 35.1473 26.1243 35.2487 26.8887L36.1618 33.7685",
    stroke: "#005A44",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.279268,
    y: -0.223065,
    width: 1.96083,
    height: 13.3111,
    rx: 0.980415,
    transform: "matrix(0.994962 -0.100256 0.122112 0.992516 31.5764 26.8766)",
    fill: "#313131",
    stroke: "#212121",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.13203,
    height: 1.39077,
    rx: 0.695385,
    transform: "matrix(0.994962 -0.100256 0.122112 0.992516 22.2886 17.8203)",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.13203,
    height: 1.39077,
    rx: 0.695385,
    transform: "matrix(0.994962 -0.100256 0.122112 0.992516 33.729 16.668)",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1553_13608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjective75);
export default __webpack_public_path__ + "static/media/objective-75.10264bbd1f3b5cbec093e9b1ff7b67be.svg";
export { ForwardRef as ReactComponent };